import { useCallback,useEffect, useState } from 'react';

import { useAppDispatch } from 'app/hooks';
import { setRows } from 'common/components/PalmDataGrid/palmDataGridSlice';
import { fetchAclEntries } from 'common/services/api/Acls/AclEntries.thunk';
import { extractStatusCode } from 'common/services/api/apiHelpers';
import { handleListFetchError } from 'common/utils/errorHandlers';
import { useSnackbar } from 'notistack';

export const useFetchUserGroupAclEntriesDefaultDataset = (item: {
	tenantId: string,
	usergroupId?: string,
	userId?: string,
	isLicenseRequired?: boolean
}) => {
    const [processing, setProcessing] = useState<boolean>(false);
    const dispatch = useAppDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const { tenantId, userId, usergroupId, isLicenseRequired } = item;

    const fetchUserGroupAclEntriesDefaultDataset = useCallback(() => {
        setProcessing(true);
        dispatch(fetchAclEntries({ tenantId, usergroupId, userId }))
            .unwrap()
            .then((response) => {
                dispatch(setRows(response));
            })
            .catch((error) => {
                dispatch(setRows([]));
                handleListFetchError(extractStatusCode(error.message), 'ACL Entry', enqueueSnackbar);
            })
            .finally(() => {
                setProcessing(false);
            });
    }, [tenantId, usergroupId, userId, isLicenseRequired]);

    useEffect(() => {
        if(isLicenseRequired) {
            return;
        }
        fetchUserGroupAclEntriesDefaultDataset();
    }, [fetchUserGroupAclEntriesDefaultDataset, isLicenseRequired]);

    const refreshUserGroupAclEntriesDefaultDataset = () => fetchUserGroupAclEntriesDefaultDataset();

    return {
        userGroupaclEntriesDefaultDatasetProcessing: processing,
        refreshUserGroupAclEntriesDefaultDataset
    };
};
